import React, { useEffect, useState } from 'react';
import { Col } from 'reactstrap';
import { getInvoicesId, postInvoice } from '../../../../../utils/api';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Range } from 'react-range';
import _ from 'lodash';
import CustomModal from '../../../../../shared/components/customComponents/CustomModal/CustomModal';
import { useSelector } from 'react-redux';


const FinancialReportStepsTwoAutomaticIncomeForm = () => {
  const [disableWithdrawBtn, setDisableWithdrawBtn] = useState(false);
  const [pageData, setPageData] = useState([]);
  const { report_id, id } = useParams();
  let navigate = useNavigate();
  const location = useLocation();
  const [total, setTotal] = useState(0);
  const [successModal, setSuccessModal] = useState(false);
  const [failedModal, setFailedModal] = useState(false);
  const [failedModalMessage, setFailedModalMessage] = useState('');
  const authUser = useSelector(state => state.auth.user);
  const [invoiceData, setInvoiceData] = useState(null);

  useEffect(() => {
    getInvoicesId(id, authUser.accessToken).then(res => {
      const total = Number(res.data.data[0].total.toFixed(2));
      const parties = res.data.data[0].parties;

      setInvoiceData(res.data.data[0]);
      setTotal(total);
      setPageData(_.map(parties, (p) => {
        return {
          id: p.user_id,
          name: p.name,
          hours: p.hours,
          amount: calculateState({
            totalValue: total,
            developerValue: p.hours,
            totalDeveloperHoursValue: _.sumBy(parties, 'hours')
          }).toString()
        };
      }));
    });
  }, [id, authUser.accessToken]);

  useEffect(() => {
    const amount = total - Math.round(_.sumBy(pageData, p => parseFloat(p.amount) || 0) * 100) / 100;
    setDisableWithdrawBtn(!(amount <= 0));
  }, [pageData, total]);

  const calculateState = ({ totalValue, totalDeveloperHoursValue, developerValue }) => {
    const number = developerValue * totalValue / totalDeveloperHoursValue;
    return Math.round(number * 100) / 100;
  };

  const calculateRange = ({ rangeValue, totalValue, pageData, index }) => {
    const clonedData = [...pageData];
    clonedData[index].amount = Number(rangeValue.toFixed(2));
    const availableAmount = totalValue - _.sumBy(clonedData, p => parseFloat(p.amount) || 0);

    return availableAmount <= 0 ? rangeValue + availableAmount : rangeValue;
  };

  const handlePostInvoice = () => {
    let parties = {
      parties: _.map(pageData, (p) => {
        return {
          id: p.id,
          amount: parseFloat(p.amount) || 0
        };
      })
    };

    postInvoice(report_id, id, parties, authUser.accessToken).then(res => {
      if (res.data.success) {
        setSuccessModal(!successModal);
      } else {
        setFailedModalMessage(typeof res.data.errors[0].message === "string" ? res.data.errors[0].message : res.data.errors[0].message.project_id[0]);
        setFailedModal(!failedModal);
      }
    });
  };

  const prevNavigationQuery = location.state?.prevQuery ? [...location.state.prevQuery] : [];

  function formatHours(hours) {
    const wholeHours = Math.floor(hours);
    const fractional = hours - wholeHours;
    const minutes = Math.round((fractional * 60));

    return `${wholeHours}:${minutes.toString().padStart(2, '0')}`;
  }

  return (
    <>
      <Col sm={12}>
        <h1>Step 2</h1>
        <h4>Invoice: #{invoiceData?.invoice_id}</h4>
        <h4>Notes: {invoiceData?.notes}</h4>
        <h4>Customer: {invoiceData?.customer?.name}</h4>
        <h4>Currency: {invoiceData?.currency}</h4>
        {invoiceData?.exchange_rate && (<h4>Exchange rate: {invoiceData?.exchange_rate}</h4>)}

        <h4>Total: {(total - _.sumBy(pageData, p => parseFloat(p.amount) || 0).toFixed(2)).toFixed(2)} USD</h4>
      </Col>
      <Col sm={12} className="mt-3">
        <div className="card">
          <div className='card-body'>
            <div className="d-flex">
              <Col className="pl-0 col-4">
                <div className='form__form-group'>
                  <span className='form__form-group-label'>DEVELOPER NAME</span>
                </div>
              </Col>
              <Col className="pl-0 col-4">
                <div className='form__form-group'>
                  <span className='form__form-group-label'>HOURS</span>
                </div>
              </Col>
              <Col className="pl-0 col-4">
                <div className='form__form-group'>
                  <span className='form__form-group-label'>INCOME</span>
                </div>
              </Col>
            </div>
            {
              _.map(pageData, (p, i) => {
                return (
                  <div className='form' key={i}>
                    <Col className='pl-0 col-4'>
                      <div className='form__form-group'>
                        <div className='form__form-group-field mt-4 mb-4'>
                          <span>{p.name}</span>
                        </div>
                      </div>
                    </Col>
                    <Col className='pl-0 col-4'>
                      <div className='form__form-group'>
                        <div className='form__form-group-field mt-4 mb-4'>
                          <span>{p.hours % 1 === 0 ? p.hours : formatHours(p.hours)}</span>
                        </div>
                      </div>
                    </Col>
                    <Col className='pl-0 col-3'>
                      <div className='form__form-group'>
                        <div className='form__form-group-field d-flex flex-column mt-3 mb-4' style={{ gap: '10px' }}>
                          <Range
                            step={0.01}
                            min={0}
                            max={total}
                            values={[parseFloat(p.amount) || 0]}
                            onChange={([val]) => {
                              const adjustedValue = calculateRange({
                                rangeValue: val,
                                totalValue: total,
                                pageData: pageData.map(p => ({ ...p })),
                                index: i
                              });

                              setPageData(prevState => {
                                const updated = [...prevState];
                                updated[i] = {
                                  ...updated[i],
                                  amount: Number(adjustedValue.toFixed(2))
                                };
                                return updated;
                              });
                            }}
                            renderTrack={({ props, children }) => {
                              const value = parseFloat(p.amount) || 0;
                              const percentage = (value / total) * 100;

                              return (
                                <div
                                  {...props}
                                  style={{
                                    ...props.style,
                                    height: '8px',
                                    width: '100%',
                                    borderRadius: '6px',
                                    background: `linear-gradient(to right, #b9f3e3 0%, #b9f3e3 ${percentage}%, #e9e9e9 ${percentage}%, #e9e9e9 100%)`
                                  }}
                                >
                                  {children}
                                </div>
                              );
                            }}
                            renderThumb={({ props }) => (
                              <div
                                {...props}
                                style={{
                                  ...props.style,
                                  height: '18px',
                                  width: '18px',
                                  backgroundColor: 'rgb(76, 225, 182)',
                                  borderRadius: '50%',
                                  boxShadow: '0 0 2px rgba(0, 0, 0, 0.5)',
                                  outline: "none"
                                }}
                              />
                            )}
                          />
                          <div className="d-flex align-items-center">
                            <span className="mr-2">$</span>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              max={total}
                              className="form-control"
                              value={p.amount}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                setPageData(prevState => {
                                  const updated = [...prevState];
                                  updated[i] = {
                                    ...updated[i],
                                    amount: inputValue
                                  };
                                  return updated;
                                });
                              }}
                              onBlur={() => {
                                setPageData(prevState => {
                                  const updated = [...prevState];
                                  const parsed = parseFloat(updated[i].amount);
                                  const adjusted = isNaN(parsed) ? 0 : calculateRange({
                                    rangeValue: parsed,
                                    totalValue: total,
                                    pageData: updated.map(p => ({ ...p })),
                                    index: i
                                  });

                                  updated[i] = {
                                    ...updated[i],
                                    amount: Number(adjusted.toFixed(2))
                                  };

                                  return updated;
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                  </div>
                );
              })
            }
            <Col className='pl-0 d-flex justify-content-end col-12'
                 style={{ borderTop: "1px solid #eceff7", paddingTop: "16px" }}>
              <button className='btn btn-primary mb-0' onClick={() => handlePostInvoice()}
                      disabled={disableWithdrawBtn}>Withdraw
              </button>
            </Col>
          </div>
        </div>
        <CustomModal
          successModal={successModal}
          toggleCloseModal={() => {
            setSuccessModal(!successModal);
            navigate(`/financials/reports/${report_id}/incomes`, {
              state: { prevQuery: prevNavigationQuery }
            });
          }}
          textModal={`The income according to invoice ${report_id} has been distributed between parties.`}
          color={"success"}
        />
        <CustomModal
          successModal={failedModal}
          toggleCloseModal={() => setFailedModal(!failedModal)}
          textModal={failedModalMessage}
          color={"danger"}
        />
      </Col>
    </>
  );
};

export default FinancialReportStepsTwoAutomaticIncomeForm;
